import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'form' ]

  update(event) {
    const status = event.detail[1]
    const code = event.detail[2].status

    // Created  201 : answer saved
    // Accepted 202 : all questions answered

    if (status === 'Accepted' || code === 202) {
      this.formTarget.disabled = false
      this.formTarget.querySelectorAll('[type="submit"]').forEach((submit) => {
        submit.disabled = false
      })
    }
  }
}
